import { render, staticRenderFns } from "./Staging-List.vue?vue&type=template&id=fbfa993e&scoped=true&"
import script from "./Staging-List.vue?vue&type=script&lang=js&"
export * from "./Staging-List.vue?vue&type=script&lang=js&"
import style0 from "./Staging-List.vue?vue&type=style&index=0&id=fbfa993e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfa993e",
  null
  
)

export default component.exports